
export default function ({ redirect, route }) {
  if (route && route.fullPath && /\/{1,}$/g.test(route.fullPath)) {
    return redirect(route.fullPath.replace(/\/{1,}$/g, ''))
  }
}
